export default __webpack_public_path__ + "static/ProValue_5@mob-53f375e1f58980489f4b13736dd342b0.webp";